import { getCurrentInstance } from 'vue';

export function useGlobalProperties() {
  const instance = getCurrentInstance() as any;
  const getGlobalProperties = () => instance.appContext.config.globalProperties || {};

  return {
    getGlobalProperties,
  };
}
